import { CustomAttributeConfigDTO } from '@ketch-com/figurehead'
import { CustomAttributeTypeOptions } from '../DataSystem/types'

export const initialCustomFieldData: CustomAttributeConfigDTO = {
  type: CustomAttributeTypeOptions.text,
  index: 0,
  label: 'Custom Field',
}
